export const SET_PROFILE = 'setProfile';
export const PROFILE_RESET_STATE = 'profileResetState';
export const SET_DAYS_OFF = 'setDaysOff';
export const PROFILE_REMOVE_WEEKDAY = 'profileRemoveWeekDay';
export const PROFILE_ADD_WEEKDAY = 'profileAddWeekDay';
export const SET_LOGO = 'setLogo';
export const SET_BANNER = 'setBanner'
export const PROFILE_REMOVE_DAY_OFF = 'profileRemoveDayOff';
export const SET_PROFILE_DAY_OFF = 'setProfileDayOff'
export const SET_PROFILE_DAYS_OFF = 'setProfileDaysOff'
export const SET_PROFILE_ACTIVE = 'setProfileActive'
